import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  public title: string = this.route.snapshot.data.title;
  public text: string = this.route.snapshot.data.text;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    const snapshotParams = this.route.snapshot.params;
    if (snapshotParams.title) {
      this.title = snapshotParams.title;
    }

    if (snapshotParams.text) {
      this.text = snapshotParams.text;
    }
  }
}
